<script>
	import { navigate } from "svelte-routing";
	import CustomTable from "../../../../components/CustomTable/CustomTable.svelte";

	export let caseData = [];
	export let changeFetchParams = () => {};

	let sortDirection = 1;

	function navigateToDetails(id) {
		// navigate to the quotation form for given case ID
		navigate(`/issues/case-management/quotation/${id}`);
	}

	function toggleSort() {
		if (sortDirection === 1) {
			sortDirection = 0;
		} else {
			sortDirection = 1;
		}
		changeFetchParams({ sortDir: sortDirection });
	}
</script>

<CustomTable
	columns={[
		{ key: "caseNo", label: "Case No." },
		{
			label: "Case Created",
			key: "createdAt",
			type: "date",
			sortCol: 1,
			event: toggleSort,
		},
		{ label: "Vehicle No", key: "plateNo", type: "link" },
		{ label: "Investigator", key: "investigator" },
		{ key: "carAssetOwners", label: "Asset Owner", type: "masterdata" },
		{
			key: "actions",
			label: "Actions",
			type: "actions",
			event: navigateToDetails,
			action: "view",
		},
	]}
	rows={caseData}
	emptyMessage="There are currently no cases to display."
/>
